import { observer } from 'mobx-react-lite'
import { JobNoteItem } from '@/features/jobs/details/components/JobNotesCard/JobNoteItem'
import { type JobNotesViewModel } from '@/features/jobs/details/components/JobNotesCard/JobNotesViewModel'
import { type JobNoteItemViewModel } from '@/features/jobs/details/components/JobNotesCard/JobNoteItem/JobNoteItemViewModel'

export interface JobNoteItemContainerProps {
  vm: JobNotesViewModel
  noteVm: JobNoteItemViewModel
}

export const JobNoteItemContainer = observer(function JobNoteItemContainer({
  vm,
  noteVm,
}: JobNoteItemContainerProps) {
  return (
    <JobNoteItem
      id={noteVm.id}
      author={{
        avatar: noteVm.author.avatar,
        avatarFallback: noteVm.author.avatarFallback,
        displayName: noteVm.author.displayName,
      }}
      displayName={noteVm.displayName}
      formattedTime={noteVm.formattedTime}
      role={noteVm.role}
      mentions={noteVm.mentions}
      body={noteVm.body}
      canDelete={vm.canDelete(noteVm)}
      onDelete={() => vm.deleteNote(noteVm)}
    />
  )
})
